import fallbackImg from "../../../mockups/assets/TELA EM BRANCO.png";
import fonte_carmo from "../../../mockups/paineis/Frame 75_transparente.png"

export default function FeaturedInauguracao({ featured }) {
  const nome = featured?.nome || "Inauguração";
  const frase = featured?.frase || "Mais uma conquista para a cidade";
  const imagem = featured?.imagem
    ? `${process.env.REACT_APP_API_URL}${featured.imagem}`
    : fallbackImg;

  return (
    <div className="flex justify-center">
      {/* <div
        className="
          w-full
          rounded-3xl
          overflow-hidden
          shadow-xl
          bg-white
          relative
        "
      > */}
        {/* HEADER */}
        {/* <div
          className="
            p-4
            text-center
            bg-blue
            text-white
            flex
            items-center
            flex-col
            gap-4
            pb-4
            min-h-[110px]
          "
        >
          <h2 className="text-4xl font-bold mt-2 pb-2">{nome}</h2>
        </div> */}

        {/* FRASE */}
        {/* <div
          className="
            absolute
            left-1/2
            -translate-x-1/2
            top-[75px]
            w-auto
            max-w-[80%]
            px-12
            h-12
            bg-white
            rounded-full
            flex
            items-center
            justify-center
            z-10
            shadow-md
          "
        >
          <p
            className="
              text-blue
              text-2xl
              font-bold
              whitespace-nowrap
              overflow-hidden
              text-ellipsis
            "
          >
            {frase}
          </p>
        </div> */}

        {/* IMAGEM */}
        {/* <img
          src={imagem}
          className="
            w-full
            h-[390px]
            object-cover
            object-bottom
            bg-gray-200
          "
          alt={nome}
          onError={(e) => {
            e.target.src = fallbackImg;
          }}
        />
      </div> */}

      <img src={fonte_carmo} alt="" />
    </div>
  );
}
